// extracted by mini-css-extract-plugin
module.exports = {"chart":"z_ch"};